"use client";
import React from "react";
import Breadcrumbs from "./components/BreadCrumb";
import HeroPage from "./components/HeroPage";
import HeroSearch from "./components/HeroSearch";
import { findPropertiesByType } from "../../constants/mockProperties";
import { memo } from "react";
import CardGrid from "../../CardGrid";
import { VariantCard, Card } from "./components/Listing";
import { PropertyType } from "src/types";
import Button from "../../ui/Button";
import { UnitsResponse } from "src/app/lib/useFetchUnits";
import CustomSelect from "./components/ui/form/CustomSelect";
import { PropertyCardSkeleton } from "../design2/components/Skeletons/Design2PropertyCard";
import DefaultPageComponent from "../../ui/DefaultPageComponent";
import { DefaultProperty } from "../../Icon";
import NoSearchCriteria from "../../ui/NoSearchCriteria";
import NoNetwork from "../../ui/NoNetwork";
import { useUnits } from "src/app/hooks/useUnits";
import { useUnitFilterTabs } from "src/app/hooks/useUnitsTabs";
export const toTitleCase = (str: string) => {
  if (str === "Block of Flat") return "Block of Flat";
  if (!str) return "";
  return str
    .toLowerCase() // Convert everything to lowercase first
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};
export const filterItems: { [key: string]: string[] } = {
  Land: [
    "sqm",
    "half plot",
    "plot",
    "acre",
    "hectare",
    "joint venture land",
    "agriculture land",
    "farm land",
    "industrial land",
    "factory land",
    "commercial land",
    "mass housing land",
    "estate land",
    "mixed use land",
  ],
  House: [
    "detached bungalow",
    "semi-detached bungalow",
    "terrace bungalow",
    "detached duplex",
    "semi-detached duplex",
    "terrace duplex",
    "skyscraper",
    "mansion structure",
    "high rise",
    "tube",
  ],
  "Block of Flat": [
    "twins",
    "three",
    "four",
    "six",
    "eight",
    "semi-detached",
    "multiple",
    "detached",
  ],
  Commercial: [
    "Church",
    "Industry",
    "Filling Station",
    "Hotel/Guest House",
    "Plaza",
    "Office Space",
    "Complex",
    "Mall",
    "Training Room",
    "Workshop",
    "Schools",
    "Shops",
    "Kiosk",
    "Stores",
    "Gas Plant",
    "Warehouse",
    "Gated Estate",
    "Car Wash",
    "Service Apartment",
    "House",
    "Facilities",
    "Tank Farm",
    "Production Factory",
    "Co Office",
    "Virtual Office",
    "Work Station",
    "Poultry",
    "Hospital",
    "Institution",
    "Quarry",
    "Lounge",
  ],
  Apartment: [
    "room & parlor",
    "single room",
    "mini flat",
    "room in flat",
    "tenement room",
    "shared house",
    "studio house",
  ],
  All: [],
};

const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
export const options = [
  { label: "Most Recent", value: "newest" },
  { label: "Least Recent", value: "oldest" },
  { label: "Most Viewed", value: "most_viewed" },
  { label: "Lowest Price", value: "lowest" },
  { label: "Highest Price", value: "highest" },
];
const ListingPage1 = ({ listings }: { listings: PropertyType[] }) => {
  return (
    <section className=" pb-8 max-w-full overflow-clip">
      <HeroPage
        max={500}
        subHeader="Your next move starts here - browse, find, and secure your perfect property today!"
        header="Property Listing"
      />
      <HeroSearch />
      <div className="">
        <div className="py-4  wrapper">
          <Breadcrumbs />
        </div>
        <View
          placeholder={listings as unknown as UnitsResponse}
          type="rent"
          properties={[
            ...findPropertiesByType("rent"),
            ...findPropertiesByType("short let"),
            ...findPropertiesByType("rent"),
            ...findPropertiesByType("sale"),
            ...findPropertiesByType("short let"),
            ...findPropertiesByType("sale"),
          ]}
        />
      </div>
    </section>
  );
};
export default ListingPage1;


export const Grid: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 13.5C9.53043 13.5 10.0391 13.7107 10.4142 14.0858C10.7893 14.4609 11 14.9696 11 15.5V19.5C11 20.0304 10.7893 20.5391 10.4142 20.9142C10.0391 21.2893 9.53043 21.5 9 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V15.5C3 14.9696 3.21071 14.4609 3.58579 14.0858C3.96086 13.7107 4.46957 13.5 5 13.5H9ZM19 13.5C19.5304 13.5 20.0391 13.7107 20.4142 14.0858C20.7893 14.4609 21 14.9696 21 15.5V19.5C21 20.0304 20.7893 20.5391 20.4142 20.9142C20.0391 21.2893 19.5304 21.5 19 21.5H15C14.4696 21.5 13.9609 21.2893 13.5858 20.9142C13.2107 20.5391 13 20.0304 13 19.5V15.5C13 14.9696 13.2107 14.4609 13.5858 14.0858C13.9609 13.7107 14.4696 13.5 15 13.5H19ZM9 3.5C9.53043 3.5 10.0391 3.71071 10.4142 4.08579C10.7893 4.46086 11 4.96957 11 5.5V9.5C11 10.0304 10.7893 10.5391 10.4142 10.9142C10.0391 11.2893 9.53043 11.5 9 11.5H5C4.46957 11.5 3.96086 11.2893 3.58579 10.9142C3.21071 10.5391 3 10.0304 3 9.5V5.5C3 4.96957 3.21071 4.46086 3.58579 4.08579C3.96086 3.71071 4.46957 3.5 5 3.5H9ZM19 3.5C19.5304 3.5 20.0391 3.71071 20.4142 4.08579C20.7893 4.46086 21 4.96957 21 5.5V9.5C21 10.0304 20.7893 10.5391 20.4142 10.9142C20.0391 11.2893 19.5304 11.5 19 11.5H15C14.4696 11.5 13.9609 11.2893 13.5858 10.9142C13.2107 10.5391 13 10.0304 13 9.5V5.5C13 4.96957 13.2107 4.46086 13.5858 4.08579C13.9609 3.71071 14.4696 3.5 15 3.5H19Z"
        fill={color}
      />
    </svg>
  );
};
export const List: React.FC<{ color: string }> = ({ color }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 7.25H21M7.5 12.5H21M7.5 17.75H21"
        stroke={color}
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 8C4.16421 8 4.5 7.66421 4.5 7.25C4.5 6.83579 4.16421 6.5 3.75 6.5C3.33579 6.5 3 6.83579 3 7.25C3 7.66421 3.33579 8 3.75 8Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 13.25C4.16421 13.25 4.5 12.9142 4.5 12.5C4.5 12.0858 4.16421 11.75 3.75 11.75C3.33579 11.75 3 12.0858 3 12.5C3 12.9142 3.33579 13.25 3.75 13.25Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 18.5C4.16421 18.5 4.5 18.1642 4.5 17.75C4.5 17.3358 4.16421 17 3.75 17C3.33579 17 3 17.3358 3 17.75C3 18.1642 3.33579 18.5 3.75 18.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export type ViewProps = "all" | "sale" | "rent" | "short let";

export const View: React.FC<{
  properties: PropertyType[];
  placeholder: UnitsResponse;
  type?: Partial<ViewProps>;
  text?: string;
  location?: string; // ✅ Add location prop
}> = ({ properties, type, text, placeholder, location }) => {
  const {
    displayedCount,
    handleLoadMore,
    view,
    setView,
    hasRelevantParams,
    setSelectedValue,
    dataToMap,
    totalResults,
    loading,
    error,
    handleSelect,
    hasMore,
    isFetching,
    unitss,
    hydrated,
    selectedValue,
  } = useUnits({ 
    isDemo, 
    placeholder, 
    properties, 
    type,
    location // ✅ Pass location to hook
  });


  // ✅ Show skeleton when loading initial data OR when refetching with filters
  const showSkeleton = (loading || (isFetching && !hydrated)) && !isDemo && type === "rent";

  if (showSkeleton) {
    return (
      <CardGrid maxColumns={view === "list" ? 2 : 4} className="wrapper">
        {Array.from({ length: 14 }).map((_, i) => (
          <PropertyCardSkeleton
            variant={view === "list" ? true : false}
            key={i}
          />
        ))}
      </CardGrid>
    );
  }

  if (error && !isDemo) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error("Property fetch error:", errorMessage);
    return <NoNetwork />;
  }

  // ✅ Calculate if we're showing all available properties
  const isShowingAll = displayedCount >= totalResults;

  return (
    <div className="mb-10 wrapper">
      <div className="flex mb-2 justify-between xs:flex-col xs:items-start xs:gap-4 items-center py-2">
        <h3 className="text-[#010A23] h5">
          <span className="text-themeColor">
            {!isDemo && type !== "rent" ? 0 : displayedCount}
          </span>{" "}
          / {isDemo || type !== "rent" ? 500 : totalResults}{" "}
          <span className="font-medium">properties found</span>
        </h3>

        <div className="flex gap-3">
          <div className="flex gap-4">
            <button
              onClick={() => setView("list")}
              className={`px-2 border rounded-lg border-themeColor py-1 transition-colors ${
                view === "list" ? "bg-themeColor text-white" : "bg-transparent hover:bg-themeColor/10"
              }`}
              aria-label="List view"
            >
              <List
                color={view === "list" ? "white" : "var(--primary-color)"}
              />
            </button>
            <button
              onClick={() => setView("grid")}
              className={`px-2 py-1 border border-themeColor rounded-lg transition-colors ${
                view === "grid" ? "bg-themeColor text-white" : "bg-transparent hover:bg-themeColor/10"
              }`}
              aria-label="Grid view"
            >
              <Grid
                color={view === "grid" ? "white" : "var(--primary-color)"}
              />
            </button>
          </div>

          <div className="select border border-themeColor px-1 rounded-lg flex items-center">
            <span>Sort by:</span>
            <CustomSelect
              options={options}
              value={selectedValue}
              onChange={setSelectedValue}
              handleSelect={handleSelect}
              placeholder="Default"
            />
          </div>
        </div>
      </div>

      <MemoizedTabs />

      {!isDemo && type !== "rent" ? (
        <DefaultPageComponent
          image="/images/not-found-optimize.gif"
          text={text || ""}
          svg={DefaultProperty}
        />
      ) : (
        <div>
          {!loading && hydrated && !isDemo && dataToMap.length === 0 ? (
            hasRelevantParams ? (
              <NoSearchCriteria />
            ) : (
              <div className="text-center">
                <DefaultPageComponent
                  image="/images/not-found-optimize.gif"
                  text={
                    text ||
                    `We're currently updating our listings. Soon, you'll be able to explore a wide range of properties - whether you're looking to rent, buy, or invest. From residential homes to commercial spaces, we've got something for everyone. Check back shortly to discover your next space!`
                  }
                  svg={DefaultProperty}
                />
              </div>
            )
          ) : (
            <>
              <CardGrid
                gap={view === "list" ? 25 : 50}
                maxColumns={view === "list" ? 2 : 4}
              >
                {/* ✅ Use dataToMap when hydrated, fallback to unitss during SSR */}
                {(hydrated ? dataToMap : unitss).map((item, index) =>
                  view === "list" ? (
                    <Card key={item.id || index} {...item} />
                  ) : (
                    <VariantCard key={item.id || index} {...item} />
                  )
                )}
              </CardGrid>

              {/* ✅ Show loading indicator during pagination fetch */}
              {isFetching && hydrated && (
                <div className="flex justify-center mt-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-themeColor"></div>
                </div>
              )}
            </>
          )}

          {/* ✅ Only show "Load More" if there are more items AND not currently fetching */}
          {hasMore && !isShowingAll && hydrated && dataToMap.length > 0 && (
            <Button
              onClick={()=> {
                handleLoadMore()
              }}
              disabled={isFetching}
              className="w-max block primary-btn mt-14 !px-4 hover:bg-themeColor/80 disabled:opacity-50 disabled:cursor-not-allowed mx-auto transition-opacity"
            >
              {isFetching ? "Loading..." : "Load More Properties"}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export type TabType =
  | "All"
  | "Land"
  | "House"
  | "Apartment"
  | "Block of Flat"
  | "Commercial";

const Tabs: React.FC = () => {
  // Predefined tab types including "All" as default
  const {
    headerItems: headerToMap,
    current,
    currentSub,
    uniqueItems,
    handleHeaderClick,
    handleSubItemClick,
  } = useUnitFilterTabs(isDemo, filterItems);

  return (
    <div className="items -ml-2 mb-5 py-4">
      <div className="first flex-wrap mb-3 divide-x divide-disabled-main flex">
        {headerToMap.map((tab) => (
          <span
            key={tab}
            onClick={() => handleHeaderClick(tab as TabType)} // Handle header click
            className={`cursor-pointer whitespace-nowrap capitalize px-2 ${
              tab.toLowerCase() === current.toLowerCase()
                ? "text-themeColor font-semibold"
                : ""
            }`}
          >
            {tab}
          </span>
        ))}
      </div>
      <div className="second flex divide-x divide-disabled-main flex-wrap">
        {current === "All"
          ? ""
          : ["all", ...uniqueItems, "others"].map((item, index) => (
              <span
                onClick={() => handleSubItemClick(item)} // Handle sub-item click
                className={`capitalize ${
                  item === "others" && "hidden"
                } cursor-pointer ${
                  item === "all" && currentSub === null && "text-themeColor"
                } hover:text-themeColor ${
                  currentSub?.toLowerCase() === item.toLowerCase() &&
                  "text-themeColor"
                } px-2 text-sm`}
                key={index}
              >
                {item}
              </span>
            ))}
      </div>
    </div>
  );
};

export const MemoizedTabs = memo(Tabs);
